// extracted by mini-css-extract-plugin
export default {"pageContainer":"StaffAttendancePage_pageContainer__mxosq","filtersRow":"StaffAttendancePage_filtersRow__gHmcj","tabContent":"StaffAttendancePage_tabContent__RSM9+"};